import {
  createEntityAdapter,
  createSlice,
  createSelector,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { ProjectProcess } from 'types/store/normalized/projectProcess';

const processesAdapter = createEntityAdapter<ProjectProcess>();
const initialState = processesAdapter.getInitialState();

const processesSlice = createSlice({
  name: 'projectsList/include/processes',
  initialState,
  reducers: {
    updateProcesses: (
      state,
      action: PayloadAction<{
        processes: ProjectProcess[];
        shouldReplace: boolean;
      }>
    ) => {
      const { processes, shouldReplace } = action.payload;
      if (shouldReplace) {
        processesAdapter.setAll(state, processes);
      } else {
        processesAdapter.upsertMany(state, processes);
      }
    },
    removeAllProcesses: (state) => {
      processesAdapter.removeAll(state);
    },
  },
});

export const { updateProcesses, removeAllProcesses } = processesSlice.actions;

const selectProcesses = (state: RootState) =>
  state.projectsList.include.processes;

export const { selectAll: selectAllProcesses, selectById: selectProcessById } =
  processesAdapter.getSelectors<RootState>(selectProcesses);

export const selectProcessesById = createSelector(
  [selectAllProcesses, (_, processes: string[]) => processes],
  (processes, processesIds) => {
    return processes.filter((process) => processesIds.includes(process.id));
  }
);

export default processesSlice.reducer;
